/**
 * Offer a text payload (e.g. an .rdp file) as a browser download.
 * Shared by the participant page and the tutor-access card (NC-1589).
 */
export function downloadTextFile(fileName: string, content: string, mime: string): void {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
